"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var util_1 = require("../util");

var qs_1 = require("qs");

exports.Mailto = function (_a) {
  var email = _a.email,
      _b = _a.subject,
      subject = _b === void 0 ? '' : _b,
      cc = _a.cc,
      bcc = _a.bcc,
      _c = _a.body,
      body = _c === void 0 ? '' : _c,
      props = tslib_1.__rest(_a, ["email", "subject", "cc", "bcc", "body"]);

  var query = qs_1.stringify({
    subject: subject,
    cc: cc && cc.join(', '),
    bcc: bcc && bcc.join(', '),
    body: body
  });
  return util_1.h('a', tslib_1.__assign({
    href: "mailto:" + email + "?" + query
  }, props));
};